import { LOGIN_BAN_URL } from '@/constants/index';
import { useRoute } from 'vue-router';
import { RouteName } from '@/router/names';

// 如果直接访问这些url，不做跳转登录页
export default function useLoginban() {
  const route = useRoute();
  if (route?.name === RouteName.Welcome) return false;
  return LOGIN_BAN_URL.includes(window.location.href);
}
